// src/pages/SalesReturnRecord/index.js
import React, { useRef } from "react";
import { App, Card, Typography, message, Button, Grid, Flex } from "antd";
import { ArrowLeftOutlined, DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReportDom from "../../components/common/ReportDom";
import SalesReturnRecordFilters from "./components/SalesReturnRecordFilters";
import SalesReturnRecordTable from "./components/SalesReturnRecordTable";
import { checkSalesReturnDelete, deleteSalesReturn, fetchSalesReturnRecord } from "./SalesReturnRecordThunk";
import Swal from "sweetalert2";
import { formatToCompanyTimezone } from "../../lib/functions";
import { exportSalesReturnRecordCsv } from "./components/exportSalesReturnRecordCsv";
import { selectAuthInfo } from "../Auth/authSelectors";

const SalesReturnRecord = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { Title } = Typography;
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const authInfo = useSelector(selectAuthInfo);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const reportRef = useRef();
  const { filters, list } = useSelector((state) => state.salesReturnRecord);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Sales Return Report",
  });

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure you want to delete this?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });

    if (!result.isConfirmed) return;

    // ✅ Step 1: Check delete possible
    // const check = await dispatch(checkSalesReturnDelete(id)).unwrap();

    // if (check.message === "no") {
    //   await Swal.fire({
    //     title: "Cannot Delete",
    //     text: "Some serials already stock out from this branch.",
    //     icon: "warning",
    //   });
    //   return;
    // }

    // ✅ Step 2: Delete
    try {
      const res = await dispatch(deleteSalesReturn(id)).unwrap();
      console.log(res, 1111, "res123rt");


      await Swal.fire({
        title: "Deleted!",
        text: "Sale return deleted successfully.",
        icon: "success",
      });
      // ✅ Refresh record list (instead of getSearchResult)
      dispatch(fetchSalesReturnRecord());

    } catch (err) {
      console.log(err, "errerr");
      Swal.fire({
        icon: "error",
        title: "Delete failed",
        text: err || "Something went wrong"
      });
    }

  };


  // Define columns dynamically
  const columns = [
    { title: "Voucher No", dataIndex: "vch_no" },
    { title: "Date", dataIndex: "date", render: (v) => v ? formatToCompanyTimezone(v).split(" ")[0] : "-", },
    { title: "Customer", dataIndex: "customer" },
    { title: "Total", dataIndex: "total", align: "right" },
  ];
  const handleDownloadCsv = () => {
    exportSalesReturnRecordCsv({
      list,
      filters,
      authInfo,
      title:    "Sales Return Record",
      filename: "sales_return_record",
    });
  };

  const hasData = list.length > 0;
  return (
    <div className="p-4">
      <Card
        className="shadow-md rounded-xl mb-4"
        title={
          <Flex align="center">
            <Button
              type="text"
              icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
              onClick={() => navigate(-1)}
              style={{ marginRight: 8, padding: 0, height: "auto", lineHeight: "1", color: "#000" }}
              data-testid="sales-return-record-back-button"
            />
            <Title level={4} style={{ margin: 0 }}>Sales Return Record</Title>
          </Flex>
        }
        extra={
          <Flex gap={8}>
            {hasData && (
              <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                {!screens.xs && "CSV"}
              </Button>
            )}
            <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
              {!screens.xs && "Print"}
            </Button>
          </Flex>
        }
        styles={{
          header: { borderBottom: "none", padding: "12px 16px" },  // replaces headStyle
          body: { padding: 0 },                                    // replaces bodyStyle
        }}
      />
      {contextHolder}
      <SalesReturnRecordFilters messageApi={messageApi} />
      <Card className="shadow-md rounded-xl">
        <SalesReturnRecordTable handleDelete={handleDelete} />
      </Card>
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <div ref={reportRef}>
          <ReportDom
            ref={reportRef}
            title="Sales Return Report"
            mode="report-page"
            filters={filters}
            // columns={columns}
            // data={list}
            renderTable={() => (
              <SalesReturnRecordTable pagination={false} printMode={true} handleDelete={handleDelete} />   /* ✅ reuse your actual table */
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default SalesReturnRecord;




